export default __webpack_public_path__ + "images/0x2791bca1f2de4661ed88a30c99a7a9449aa84174.png";